import script from "./LootBoxStats.vue?vue&type=script&setup=true&lang=js"
export * from "./LootBoxStats.vue?vue&type=script&setup=true&lang=js"

import "./LootBoxStats.vue?vue&type=style&index=0&id=a76d03f6&lang=scss"

const __exports__ = script;

export default __exports__